(function () {
  'use strict';

  /* @ngdoc object
   * @name crewFlyingDetailsReport
   * @description
   *
   */
  angular
    .module('crewFlyingDetailsReport', [
      'ui.router'
    ]);
}());
